import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {StorageUtils} from '../../../utils/storage-utils';
import {Company} from '../company/company';
import {RestService} from '../../../utils/rest-service';
import {JsonContainer} from '../../../utils/json-container';
import { Person } from 'app/pages/person/person/person';


@Injectable()
export class PartnerService extends RestService {

    constructor(private client: HttpClient, private storageUtils: StorageUtils) {
        super(client, 'partner', storageUtils);
    }

    save(company: Company, callback: (result: JsonContainer, company: Company) => void) {
        this.executePut('save', company, callback)
    }

    searchCompany(document: string, callback: (result: JsonContainer, roles: Company) => void) {
        this.executeGet('searchCompany/' + document, callback)
    }

    listPartners(callback: (result: JsonContainer, comps: Company[]) => void) {
        this.executeGet('listPartners', callback)
    }

    listPartnersCompanyInfo(idCompany: string, callback: (result: JsonContainer, comps: Company[]) => void) {
        this.executeGet('listPartners/' + idCompany, callback)
    }
    
    listPartnersByCompanyId(idCompany: string, callback: (result: JsonContainer, comps: Company[]) => void) {
        this.executeGet('listPartnersComp/' + idCompany, callback)
    }

    totalInvoiceIssuedToMe(callback: (result: JsonContainer, total: number) => void) {
        this.executeGet('totalInvoiceIssuedToMe', callback)
    }

    changePartnerDesc(companyId: string, callback: (result: JsonContainer) => void){
        this.executePost('changePartnerDesc', companyId, callback)
    }

    getActiveClientsTotal(companyId: string, callback: (result: JsonContainer, total: number) => void) {
        this.executeGet('getActiveClientsTotal/' + companyId, callback)
    }

    listSIMEI(partnerId: string, callback: (result: JsonContainer, companies: Company[]) => void) {
        this.executeGet('listSIMEI/' + partnerId, callback)
    }

    updatePartnerByDocument(companyId: string, partnerDocument: string, newPartnerData: Person, callback: (result: JsonContainer) => void) {
        const path = `updatePartner/${companyId}/${partnerDocument}`;
        this.executePut(path, newPartnerData, callback);
    }
}
